import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawNotification {
  reorder: {
    show: boolean
  }
}

export class Notification extends AbstractValue<RawNotification> {
  get reorder(): Reorder {
    return new Reorder(this.raw.reorder)
  }
}

export class Reorder extends AbstractValue<{
  show: boolean
}> {
  get show(): boolean {
    return this.raw.show
  }
}
